import withModalControls, {
  WithModalControlsProps
} from '@anm/HOCs/withModalControls';
import { CardProps } from '@anm/components/Card';
import Button from '@anm/components/buttons/Button';
import CardModal from '@anm/components/modals/CardModal';
import { FC } from 'react';

import CalendarSyncLinks from './CalendarSyncLinks';

export type CalendarSyncProps = WithModalControlsProps & {};

const cardSettings: CardProps = {
  variant: 'white',
  isPadding: false
};

const CalendarSync: FC<CalendarSyncProps> = ({
  openModal,
  closeModal,
  isModalOpened
}) => (
  <>
    <Button variant="white-blue-border-share" size="large" onClick={openModal}>
      Sync with My Calendar
    </Button>
    {isModalOpened && (
      <CardModal onModalClose={closeModal} cardSettings={cardSettings}>
        <CalendarSyncLinks />
      </CardModal>
    )}
  </>
);

export default withModalControls(CalendarSync);
